<template>
    <div class="main-container px-1 md:px-8 py-5">
        <div class="card ">
            <Toast />
            <AdminIndex v-if="isAdmin" />
            <UserIndex v-else />
        </div>
    </div>
</template>
<script setup>
import { computed } from "vue";
import { useStore } from 'vuex';

import AdminIndex from './AdminIndex.vue';
import UserIndex from './UserIndex.vue';

const store = useStore();
const isAdmin = computed(() => store.getters.isAdmin);


</script>

<style scoped>
.modal-content {
    width: 100vw;
    /* Adjust the width as necessary */
}
</style>